import styled from 'styled-components';
import { Meter } from 'ui/chart';
import { getMeterOptions } from './audienceCountsTable/hooks/getMeterChartOptions';
import { PieChartProps } from './audienceCountsTable/PieChart';

type AudienceMeterChartProps = Omit<PieChartProps, 'hasChart'>;

const StyledMeter = styled(Meter)`
  padding: ${({ theme }) => theme.spacing.values.half} 0;
`;

export const AudienceMeterChart = ({
  audienceCounts,
  isLoading = false,
  isEnabled = false,
}: AudienceMeterChartProps) => {
  const meterBarValues = getMeterOptions(audienceCounts ?? []);
  if (!isEnabled) return null;

  return (
    <StyledMeter
      options={meterBarValues}
      isLoading={isLoading}
      isAccessible={false}
      hasHighlight
      hasTooltip
    />
  );
};
